import { ajaxJson } from "imports/ajax";
import { map2UserObj } from "imports/mapper";
import * as auth from "imports/auth";
import { userActionCreators } from "db/user/user.action";
import { createTypes } from "redux-create-types";
import { toast } from "react-toastify";
import history from "imports/history";

const namespace = "page-login";

export const loginActions = createTypes(
    [
        "toggleSpinner",
        "setError",
        "setToken",
        "setPhoneNumber",
        "changeStep",
        "hideSendAgain",
        "showSendAgain",
        "disableSendAgain",
        "enableSendAgain",
        "setCanSubmitPhoneNumber"
    ],
    namespace
);

function setCanSubmitPhoneNumber(flag) {
    return dispatch => {
        return dispatch({
            type: loginActions.setCanSubmitPhoneNumber,
            payload: flag
        });
    };
}

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: loginActions.toggleSpinner,
            payload: true,
            meta: { apiName }
        });
    };
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: loginActions.toggleSpinner,
            payload: false,
            meta: { apiName }
        });
    };
}

function setToken(token, exp) {
    return dispatch => {
        dispatch({
            type: loginActions.setToken,
            payload: {
                token,
                exp
            }
        });
    };
}

function setPhoneNumber(phoneNumber) {
    return dispatch => {
        dispatch({
            type: loginActions.setPhoneNumber,
            payload: {
                phoneNumber
            }
        });
    };
}

function changeStep(step) {
    return dispatch => {
        const accessSteps = [1, 2, 3, 4];
        if (!accessSteps.includes(step)) {
            throw new Error("wrong step selected");
        }
        dispatch({
            type: loginActions.changeStep,
            payload: {
                step
            }
        });
    };
}

function showSendAgain() {
    return dispatch => {
        dispatch({
            type: loginActions.showSendAgain
        });
    };
}

function hideSendAgain() {
    return dispatch => {
        dispatch({
            type: loginActions.hideSendAgain
        });
    };
}

function postPhoneNumberApiFail(err) {
    return dispatch => {
        dispatch(setCanSubmitPhoneNumber(true));
        return dispatch => {
            dispatch({
                type: loginActions.setError,
                payload: err
            });
            return dispatch(hideSpinner("post-phone"));
        };
    };
}

function postPhoneNumberApiSuccess(res, phoneNumber) {
    return dispatch => {
        dispatch(setToken(res.data.token, res.data.expire_time));
        dispatch(setPhoneNumber(phoneNumber));
        switch (res.data["next_step"]) {
            case "login_with_OTP":
                dispatch(changeStep(2));
                dispatch(hideSendAgain());
                setTimeout(() => {
                    dispatch(showSendAgain());
                }, 5000);
                toast.success("کد ورود از طریق پیامک ارسال شد.");
                break;
            case "signup":
                dispatch(changeStep(3));
                break;
            case "login_with_password":
                dispatch(changeStep(4));
                break;
            default:
                throw new Error("unexpected step in post phon number api");
        }
        dispatch(setCanSubmitPhoneNumber(true));
        dispatch(hideSpinner("post-phone"));
    };
}

function postPhoneNumberToApi(phoneNumber) {
    return dispatch => {
        dispatch(setCanSubmitPhoneNumber(false));
        dispatch(showSpinner("post-phone"));
        const bodyData = {
            phone: phoneNumber
        };
        return ajaxJson.post("/users", bodyData).then(
            res => dispatch(postPhoneNumberApiSuccess(res, phoneNumber)),
            err => dispatch(postPhoneNumberApiFail(err))
        );
    };
}

function postLoginApiFail(err) {
    return dispatch => {
        dispatch({
            type: loginActions.setError,
            payload: err
        });
        return dispatch(hideSpinner("login"));
    };
}

function postLoginApiSuccess(res, go) {
    return dispatch => {
        const userObj = map2UserObj(res.data);
        auth.login({
            token: res.data["access_token"],
            ...userObj
        });
        dispatch(userActionCreators.set(userObj));
        if (go) {
            history.replace(go);
        } else {
            history.push("/");
        }
    };
}

function postLoginToApi(code, go) {
    return (dispatch, getState) => {
        const token = getState().ui.loginPage.token;
        dispatch(showSpinner("login"));
        const bodyData = {
            token,
            code
        };
        return ajaxJson.post("/users/verification", bodyData).then(
            res => dispatch(postLoginApiSuccess(res, go)),
            err => dispatch(postLoginApiFail(err))
        );
    };
}

function registerSuccess(res, go) {
    return dispatch => {
        const userObj = map2UserObj(res.data);
        auth.login({
            token: res.data["access_token"],
            ...userObj
        });
        dispatch(userActionCreators.set(userObj));
        if (go) {
            history.replace(go);
        } else {
            history.push("/");
        }
    };
}

function registerFail(err) {
    return dispatch => {
        dispatch({
            type: loginActions.setError,
            payload: err
        });
        return dispatch(hideSpinner("register"));
    };
}

function register(email, pass1, pass2, go) {
    return (dispatch, getState) => {
        const token = getState().ui.loginPage.token;
        dispatch(showSpinner("register"));
        const bodyData = {
            email: email,
            password1: pass1,
            password2: pass2,
            token
        };
        return ajaxJson.post("/users/signup", bodyData).then(
            res => dispatch(registerSuccess(res, go)),
            err => dispatch(postLoginApiFail(err))
        );
    };
}

function loginByPasswordSuccess(res, go) {
    return dispatch => {
        const userObj = map2UserObj(res.data);
        auth.login({
            token: res.data["access_token"],
            ...userObj
        });
        dispatch(userActionCreators.set(userObj));
        if (go) {
            history.replace(go);
        } else {
            history.push("/");
        }
    };
}

function loginByPasswordFail(err) {
    return dispatch => {
        dispatch({
            type: loginActions.setError,
            payload: err
        });
        return dispatch(hideSpinner("login"));
    };
}

function loginByPassword(password, go) {
    return (dispatch, getState) => {
        const token = getState().ui.loginPage.token;
        dispatch(showSpinner("login"));
        const bodyData = {
            password,
            token
        };
        return ajaxJson.post("/users/login", bodyData).then(
            res => dispatch(loginByPasswordSuccess(res, go)),
            err => dispatch(loginByPasswordFail(err))
        );
    };
}

export const loginActionCreators = {
    postPhoneNumberToApi,
    postLoginToApi,
    changeStep,
    register,
    loginByPassword
};
